Ext.define('SA.EditHeader', {
    alias: 'widget.edit-header',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-header',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-edit-header-upper',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-edit-header-text',
                    itemId: 'titleCmp'
                }, {
                    xtype: 'sa-button',
                    cls: 'sa-edit-header-done-btn',
                    itemId: 'doneBtn',
                    text: 'Done',
                    ui: 'primary'
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-edit-header-warning',
            hidden: true,
            itemId: 'warningCmp',

            tpl: [
                '<svg class="sa-edit-header-warning-svg"><use href="#sa-icon-warning"></use></svg>',
                '<div>{message}</div>'
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.titleCmp = this.down('#titleCmp');
        this.doneBtn = this.down('#doneBtn');
        this.warningCmp = this.down('#warningCmp');

        this.doneBtn.setEnabled(this.enableDoneButton ?? false);

        this.doneBtn.on('click', () => this.fireEvent('done:click'));
    },

    setTitleHtml(titleHtml) {
        this.titleCmp.update(titleHtml);
    },

    setWarningMessage(message) {
        this.doneBtn.setEnabled(!message);

        this.warningCmp.update({message});
        this.warningCmp.setVisible(!!message);
    }
});